import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Modal} from 'shells/modal/modal';
import {Switch} from 'shells/switch/switch';
import {Body} from 'shells/typography/body';

import {useGetSessionUser} from '../../../core/use-get-session-user';
import {useToggleShortcuts} from '../../../navigation/sidebar/use-toggle-shortcuts';

import {ShortcutsGrid} from './shortcuts-grid';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function KeyboardShortcutsModal(props: Props) {
    const {user} = useGetSessionUser();

    const toggleShortcuts = useToggleShortcuts();

    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.onClose}
            headerText='Keyboard shortcuts'
            maxHeight={700}
        >
            <StackLegacy spacing={8}>
                <StackLegacy isHorizontal={true} spacing={8}>
                    <Switch
                        isRounded={true}
                        isSmall={true}
                        isOn={Boolean(user && !user.hasDisabledShortcuts)}
                        onChange={() => {
                            if (user) {
                                toggleShortcuts(user);
                            }
                        }}
                    />
                    <div className='mt-4'>
                        <Body size='small'>Enable keyboard shortcuts</Body>
                    </div>
                </StackLegacy>
                <ShortcutsGrid />
            </StackLegacy>
        </Modal>
    );
}
